import { SET_CAMPAIGN_SOURCE_TYPE } from 'actions';

export function setCampaignSourceType(sourceType: string) {
  return { sourceType, type: SET_CAMPAIGN_SOURCE_TYPE };
}
